// extracted by mini-css-extract-plugin
module.exports = {"profile-link__image":"ProfileLink_profile-link__image__nf2l6"};